import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import logo from '../assets/images/camdiab-logo.png';
import mobile_logo from '../assets/images/mobile-logo.svg';
import {
    COUNTRY_OPTIONS,
    consumeCountryReturnPath,
    getCountryForLanguage,
    getStoredCountryId,
    rewritePathForLanguage,
    setStoredCountryId,
} from '../utils/countries';
import {getLanguagePrefix} from '../utils/language';

export class CountryLanguage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedId: getStoredCountryId() || getCountryForLanguage(this.props.language).id,
        };
    }

    componentDidMount() {
        document.body.classList.remove('open-toggle');
        document.body.classList.remove('open-language');
    }

    handleSelect = (option) => {
        setStoredCountryId(option.id);
        this.setState({selectedId: option.id});

        if (typeof this.props.setSiteLanguage === 'function') {
            this.props.setSiteLanguage(option.languageCode);
        }

        const returnPath = consumeCountryReturnPath() || '/';
        const targetPath = rewritePathForLanguage(returnPath, option.languageCode);
        this.props.history.push(targetPath);
    };

    handleClose = () => {
        const returnPath = consumeCountryReturnPath();
        if (returnPath) {
            this.props.history.push(returnPath);
            return;
        }
        if (this.props.history.length > 1) {
            this.props.history.goBack();
            return;
        }
        this.props.history.push(getLanguagePrefix(this.props.language) + '/');
    };

    render() {
        const homePrefix = getLanguagePrefix(this.props.language);
        const {selectedId} = this.state;

        return (
            <div className="country-language-page">
                <Helmet>
                    <title>Choose your country and language | CamDiab</title>
                </Helmet>
                <header className="country-language-header">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-12 col-sm-12 header-wrap">
                                <div className="logo">
                                    <NavLink to={homePrefix + '/'}>
                                        <img src={logo} className="App-logo" alt="CamDiab"/>
                                        <img src={mobile_logo} className="mobile-logo" alt="CamDiab"/>
                                    </NavLink>
                                </div>
                                {/* Invisible menu-icon spacer so mobile logo centers like the main header */}
                                <div className="header-navigation country-language-nav-spacer" aria-hidden="true">
                                    <div className="menu-icon">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <main className="country-language-main">
                    <div className="country-language-title-row">
                        <h1 className="country-language-title">Choose your country and language</h1>
                        <button
                            type="button"
                            className="country-language-close"
                            onClick={this.handleClose}
                            aria-label="Close"
                            title="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="country-language-grid">
                        {COUNTRY_OPTIONS.map((option) => {
                            const isActive = option.id === selectedId;
                            return (
                                <button
                                    key={option.id}
                                    type="button"
                                    className={`country-language-option${isActive ? ' is-active' : ''}`}
                                    onClick={() => this.handleSelect(option)}
                                >
                                    <img
                                        className="country-language-flag"
                                        src={`https://flagcdn.com/w80/${option.countryCode.toLowerCase()}.png`}
                                        srcSet={`https://flagcdn.com/w40/${option.countryCode.toLowerCase()}.png 1x, https://flagcdn.com/w80/${option.countryCode.toLowerCase()}.png 2x`}
                                        width="32"
                                        height="24"
                                        alt=""
                                        loading="lazy"
                                    />
                                    <span className="country-language-texts">
                                        <span className="country-language-country">{option.countryName}</span>
                                        <span className="country-language-lang">{option.languageLabel}</span>
                                    </span>
                                </button>
                            );
                        })}
                    </div>
                </main>
            </div>
        );
    }
}
